import { FC } from 'react'
import { Tabs } from 'antd'

import style from './style.m.less'
import { Card } from '../ui'
import { Closed, Opened } from './components'
import { useTranslation } from 'react-i18next'

const { TabPane } = Tabs

const GOApproval: FC = () => {
    const { t } = useTranslation()

    return (
        <div className={style.container}>
            <h1 className={style.title}>{t('gOApproval.title')}</h1>
            <div className={style.tabs}>
                {/* <Tabs defaultActiveKey="1">
                    <TabPane tab={t('gOApproval.opened')} key="1">
                        <Card>
                            <Opened />
                        </Card>
                    </TabPane>
                    <TabPane tab={t('gOApproval.closed')} key="2">
                        <Card>
                            <Closed />
                        </Card>
                    </TabPane>
                </Tabs> */}
                <Card>
                    <Closed />
                </Card>
            </div>
        </div>
    )
}

export default GOApproval
